import { styled } from '../../../../utils/styled';
import { propStyles } from '../../../../utils/propStyles';

const DocumentsPaginationButtons = styled<any, any>(
    'div',
    'documentsPaginationButtons',
    'documentsGrid'
)`
    ${propStyles};
`;

DocumentsPaginationButtons.defaultProps = {
    display: 'flex',
    alignItems: 'center',
};

export default DocumentsPaginationButtons;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentsGrid/StyledComponents/DocumentsPaginationButtons.tsx